import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || 'Plus'}</title>
      <g>
        <path d="M478.4 200.1c8.6 0 15.9 3 22 9.1s9.1 13.4 9.1 22v47.7c0 8.6-3 15.9-9.1 22s-13.4 9.1-22 9.1h-168.1v167.6c0 9.1-3 16.6-9.1 22.6-6.1 6.1-13.4 9.1-22 9.1h-47.7c-8.6 0-15.9-3-22-9.1-6.1-6-9.1-13.4-9.1-22v-168.2h-167.6c-9 0-16.6-2.9-22.7-8.8-6-5.8-9.1-13.3-9.1-22.3v-47.7c0-8.6 3-15.9 9.1-22 6.1-6 13.4-9.1 22-9.1h168.2v-167.5c0-9.1 3-16.6 8.8-22.7 5.9-6 13.3-9.1 22.4-9.1h47.7c8.6 0 15.9 3.1 22 9.1 6.1 6.1 9.1 13.4 9.1 22v168.2h168.1z" />
      </g>
    </Icon>
  )
}
